import { Routes, Route, Navigate } from "react-router-dom";
import MyFeed from "../screens/MyFeed/MyFeed";
import MyCommunities from "../screens/MyCommunities/MyCommunities";
import MyCampus from "../screens/MyCampus/MyCampus";
import MyEvents from "../screens/MyEvents/MyEvents";
import CommunityPage from "../screens/CommunityPage/CommunityPage";
import CoursePage from "../screens/CoursePage/CoursePage";
import Modal from "../core/Modal/Modal";
import CommunityPopup from "../content/Communities/CommunityPopup/CommunityPopup";
import EditPersonalInfoPopup from "../content/Profile/EditPersonalInfoPopup/EditPersonalInfoPopup";
import { useSelector } from "react-redux";
import { Search } from "../screens/Search/Search";
import { CoursePageLibrary } from "../screens/CoursePageLibrary/CoursePageLibrary";
import FullContentPage from "../screens/FullContentPage/FullContentPage";
import { EventPage } from "../screens/EventPage/EventPage";
import { EventPageLibrary } from "../screens/EventPageLibrary/EventPageLibrary";
import Curricula from "../screens/Curricula/Curricula";
import CurriculumPage from "../screens/CurriculumPage/CurriculumPage";
import ShiHRPage from "../screens/SHIhr/ShiHRPage";
import { EventPageTasks } from "../screens/EventPageTasks/EventPageTasks";
import { EventParticipantsPage } from "../screens/EventParticipantsPage/EventParticipantsPage";
import Help from "../screens/Help/Help";
import HelpItemPage from "../screens/HelpItemPage/HelpItemPage";

const MyRoutes = () => {
  const { showCommunityPopup, showPersonalInfoPopup } = useSelector((state: any) => state.main);
  const isMobile = navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/iPhone/i);

  return (
    <div className="page">
      <Routes>
        {/* Redirect based on user agent */}
        <Route path="/" element={<Navigate to={isMobile ? "/my-campus" : "/my-feed"} />} />
        <Route path="/my-feed" element={<MyFeed />} />
        <Route path="/my-communities" element={<MyCommunities />} />
        <Route path="/my-campus" element={<MyCampus />} />
        <Route path="/curricula" element={<Curricula />} />
        <Route path="/curricula/curriculum/:id" element={<CurriculumPage />} />
        <Route path="/shihr" element={<ShiHRPage />} />
        <Route path="/my-campus/course/timeline/:id" element={<CoursePage />} />
        <Route path="/my-campus/course/library/:id" element={<CoursePageLibrary />} />
        <Route path="/my-campus/event/timeline/:id" element={<EventPage />} />
        <Route path="/my-campus/event/participants/:id" element={<EventParticipantsPage />} />
        <Route path="/my-campus/event/library/:id" element={<EventPageLibrary />} />
        <Route path="/my-campus/event/tasks/:id" element={<EventPageTasks />} />
        <Route path="/my-events" element={<MyEvents />} />
        <Route path="/community/:id" element={<CommunityPage />} />
        <Route path="/content/:id" element={<FullContentPage />} />
        <Route path="/search/:term" element={<Search />} />
        <Route path="/help" element={<Help />} />
        <Route path="/help/:id" element={<HelpItemPage />} />

        {/* Catch-all route */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <Modal show={showCommunityPopup}>
        <CommunityPopup />
      </Modal>
      <Modal show={showPersonalInfoPopup}>
        <EditPersonalInfoPopup isPopup={true} isNew={false} />
      </Modal>
    </div>
  );
};

export default MyRoutes;
